// extracted by mini-css-extract-plugin
export var navbarSubLink = "C_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "C_tZ d_f0 d_dB";
export var subPageLink = "C_gf d_gf";
export var burger = "C_wc";
export var sublinkSize = "C_wd";
export var linkSize = "C_wf";
export var Link = "C_rD q_rD q_qV q_rd";